import * as angular from 'angular';

import { IDispatcherService, IDispatcher, ITicketActionsService } from '../';
import { Ticket } from '../../models';

export interface ITicketStoreService {
    getOne: (id: number, force?: boolean) => angular.IPromise<Ticket>;
    getAll: (force?: boolean) => angular.IPromise<Ticket[]>;
    addOne: (target: Ticket) => angular.IPromise<Ticket[]>;
    addMany: (targets: Ticket[]) => angular.IPromise<Ticket[]>;
    updateOne: (target: Ticket) => angular.IPromise<Ticket[]>;
    updateMany: (targets: Ticket[]) => angular.IPromise<Ticket[]>;
}

export interface ITicketActionDispatcherService extends IDispatcherService<ITicketStoreService> { }

export class TicketsActionDispatcherService implements ITicketActionDispatcherService {
    static serviceId = 'ticketActionDispatcherService';

    static $inject = ['ticketActionsService'];

    constructor(private _actionService: ITicketActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITicketStoreService> {
        return {
            dispatcher: {
                getOne: (id: number, force?: boolean) => dispatch(this._actionService.getOne(id, force)),
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force)),
                addOne: (target: Ticket) => dispatch(this._actionService.addOne(target)),
                addMany: (targets: Ticket[]) => dispatch(this._actionService.addMany(targets)),
                updateOne: (target: Ticket) => dispatch(this._actionService.updateOne(target)),
                updateMany: (targets: Ticket[]) => dispatch(this._actionService.updateMany(targets))
            }
        };
    }
}